import { FiX } from "react-icons/fi"
import { titleCase } from "../../utils/helpers"

const inputStyles =
  "text-black text-sm px-2 py-1.5 border border-gray-300 rounded w-full placeholder:text-gray-400 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-0"

const labelStyles = "block text-gray-600 font-semibold text-sm"

export const Tool = ({
  question,
  index,
  handleOnChange,
  removeQuestion,
  handleCheckbox,
}) => {
  return (
    <div className="rounded-lg border border-gray-200">
      <div className="flex justify-between items-center px-2 py-3 bg-slate-200 rounded-t-lg">
        <span
          className={labelStyles}
        >{`How many years of experience do you have using [${titleCase(
          question.screening_question_group
        )}] ?`}</span>
        <FiX
          size={24}
          onClick={() => removeQuestion(index)}
          className="cursor-pointer"
        />
      </div>
      <div className="flex justify-between items-end px-2 py-4">
        <div className="flex items-center space-x-3">
          <div>
            <label htmlFor="question" className={labelStyles}>{`${titleCase(
              question.screening_question_group
            )} *`}</label>
            <input
              type="text"
              name="screening_question_value"
              value={titleCase(question.screening_question_value)}
              onChange={e => handleOnChange(e, index)}
              className={inputStyles}
              key="toolQuestion"
            />
          </div>
          <div>
            <label htmlFor="answer" className={labelStyles}>
              Ideal Answer
            </label>
            <div className="flex items-end">
              <input
                type="text"
                name="screening_required_answer"
                value={titleCase(question.screening_required_answer)}
                className={`${inputStyles} w-10 mr-2`}
                onChange={e => handleOnChange(e, index)}
                key="toolAnswer"
              />
              <span className={labelStyles}>minimum</span>
            </div>
          </div>
        </div>
        <div className="flex items-end">
          <input
            type="checkbox"
            name="screening_must_have_qualification"
            className="mr-2 w-5 h-5 accent-green-600"
            defaultChecked={
              question?.screening_must_have_qualification === "1"
                ? true
                : question?.screening_must_have_qualification === "0"
                ? false
                : question?.screening_must_have_qualification
            }
            onChange={e => handleCheckbox(e, index)}
          />
          <label htmlFor="mustHave" className={labelStyles}>
            Must-have qualification
          </label>
        </div>
      </div>
    </div>
  )
}

export const Language = ({
  question,
  index,
  handleOnChange,
  removeQuestion,
  handleCheckbox,
}) => {
  return (
    <div className="rounded-lg border border-gray-200">
      <div className="flex justify-between items-center px-2 py-3 bg-slate-200 rounded-t-lg">
        <span
          className={labelStyles}
        >{`What is your level of proficiency in [${titleCase(
          question.screening_question_group
        )}] ?`}</span>
        <FiX
          size={24}
          onClick={() => removeQuestion(index)}
          className="cursor-pointer"
        />
      </div>
      <div className="flex justify-between items-end px-2 py-4">
        <div className="flex items-center space-x-3">
          <div>
            <label htmlFor="question" className={labelStyles}>{`${titleCase(
              question.screening_question_group
            )} *`}</label>
            <input
              type="text"
              name="screening_question_value"
              value={titleCase(question.screening_question_value)}
              className={inputStyles}
              onChange={e => handleOnChange(e, index)}
              key="languageQuestion"
            />
          </div>
          <div>
            <label htmlFor="answer" className={labelStyles}>
              Ideal Answer
            </label>
            <div className="flex items-end">
              <select
                name="screening_required_answer"
                value={titleCase(question.screening_required_answer)}
                className={`${inputStyles} mr-2`}
                onChange={e => handleOnChange(e, index)}
              >
                <option value="">Please Choose</option>
                <option value="beginner">Beginner</option>
                <option value="intermediate">Intermediate</option>
                <option value="expert">Expert</option>
                <option value="native">Native</option>
              </select>
              <span className={labelStyles}>minimum</span>
            </div>
          </div>
        </div>
        <div className="flex items-end">
          <input
            type="checkbox"
            name="screening_must_have_qualification"
            className="mr-2 w-5 h-5 accent-green-600"
            defaultChecked={
              question?.screening_must_have_qualification === "1"
                ? true
                : question?.screening_must_have_qualification === "0"
                ? false
                : question?.screening_must_have_qualification
            }
            onChange={e => handleCheckbox(e, index)}
          />
          <label htmlFor="mustHave" className={labelStyles}>
            Must-have qualification
          </label>
        </div>
      </div>
    </div>
  )
}

export const Industry = ({
  question,
  index,
  handleOnChange,
  removeQuestion,
  handleCheckbox,
}) => {
  return (
    <div className="rounded-lg border border-gray-200">
      <div className="flex justify-between items-center px-2 py-3 bg-slate-200 rounded-t-lg">
        <span className={labelStyles}>{`How many years of [${titleCase(
          question.screening_question_group
        )}] experience do you currently have?`}</span>
        <FiX
          size={24}
          onClick={() => removeQuestion(index)}
          className="cursor-pointer"
        />
      </div>
      <div className="flex justify-between items-end px-2 py-4">
        <div className="flex items-center space-x-3">
          <div>
            <label htmlFor="question" className={labelStyles}>{`${titleCase(
              question.screening_question_group
            )} *`}</label>
            <input
              type="text"
              name="screening_question_value"
              value={titleCase(question.screening_question_value)}
              className={inputStyles}
              onChange={e => handleOnChange(e, index)}
              key="industryQuestion"
            />
          </div>
          <div>
            <label htmlFor="answer" className={labelStyles}>
              Ideal Answer
            </label>
            <div className="flex items-end">
              <input
                type="text"
                name="screening_required_answer"
                value={titleCase(question.screening_required_answer)}
                className={`${inputStyles} w-10 mr-2`}
                onChange={e => handleOnChange(e, index)}
                key="industryAnswer"
              />
              <span className={labelStyles}>minimum</span>
            </div>
          </div>
        </div>
        <div className="flex items-end">
          <input
            type="checkbox"
            name="screening_must_have_qualification"
            className="mr-2 w-5 h-5 accent-green-600"
            defaultChecked={
              question?.screening_must_have_qualification === "1"
                ? true
                : question?.screening_must_have_qualification === "0"
                ? false
                : question?.screening_must_have_qualification
            }
            onChange={e => handleCheckbox(e, index)}
          />
          <label htmlFor="mustHave" className={labelStyles}>
            Must-have qualification
          </label>
        </div>
      </div>
    </div>
  )
}

export const Custom = ({
  question,
  index,
  handleOnChange,
  removeQuestion,
  handleCheckbox,
}) => {
  return (
    <div className="rounded-lg border border-gray-200">
      <div className="flex justify-between items-center px-2 py-3 bg-slate-200 rounded-t-lg">
        <span className={labelStyles}>Write a custom screening question.</span>
        <FiX
          size={24}
          onClick={() => removeQuestion(index)}
          className="cursor-pointer"
        />
      </div>
      <div className="px-2 py-4">
        <input
          type="text"
          name="screening_question_value"
          value={titleCase(question.screening_question_value)}
          placeholder="Try asking a question like, 'Will you be able to bring your own device?'"
          className="text-black text-sm px-2 py-4 border border-gray-300 rounded w-full placeholder:text-gray-400 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-0"
          onChange={e => handleOnChange(e, index)}
          key="customQuestion"
        />
      </div>
      <div className="flex justify-between items-end px-2 py-4">
        <div className="flex items-end space-x-3">
          <div>
            <label
              htmlFor={`custom-response-type-${index}`}
              className={labelStyles}
            >
              Response Type
            </label>
            <div className="flex items-end">
              <select
                name={`custom-response-type-${index}`}
                className={`${inputStyles} mr-2`}
              >
                <option value="yesOrNo">Yes / No</option>
              </select>
              <span className={labelStyles}>minimum</span>
            </div>
          </div>
          <div>
            <label htmlFor="answer" className={labelStyles}>
              Ideal Answer
            </label>
            <div className="flex items-end">
              <select
                name="screening_required_answer"
                value={titleCase(question.screening_required_answer)}
                className={`${inputStyles} mr-2`}
                onChange={e => handleOnChange(e, index)}
              >
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
              <span className={labelStyles}>minimum</span>
            </div>
          </div>
        </div>

        <div className="flex items-end">
          <input
            type="checkbox"
            name="screening_must_have_qualification"
            className="mr-2 w-5 h-5 accent-green-600"
            defaultChecked={
              question?.screening_must_have_qualification === "1"
                ? true
                : question?.screening_must_have_qualification === "0"
                ? false
                : question?.screening_must_have_qualification
            }
            onChange={e => handleCheckbox(e, index)}
          />
          <label htmlFor="mustHave" className={labelStyles}>
            Must-have qualification
          </label>
        </div>
      </div>
    </div>
  )
}
